import angular from 'angular'

import { wrap } from 'lodash-es'

import deline from '../utils/deline'

angular
  .module('ggs.element-query')
  .directive('ggsElementQuery', ElementQueryDirective)

function ElementQueryDirective(
  $parse,
  applyAsync,
  ElementQueryInternal) {

  return {
    restrict: 'A',
    priority: 400,
    link: {
      pre: preLink
    }
  }

  function preLink($scope, $elm, $attr) {
    const format = /^(.+?)=(.+)$/
    const input = $attr.ggsElementQuery.replace(/(\d+)px/g, '$1')
    const match = format.exec(input)

    const queryAttr = deline(match[2])
    const modelAttr = deline(match[1])
    const emitterAttr = deline($attr.ggsElementQueryEmitter)

    const ngQuery = $parse(queryAttr)
    const ngModel = $parse(modelAttr)
    const ngEmitter = $parse(emitterAttr)

    const get = wrap($scope, ngModel)
    const set = wrap($scope, ngModel.assign)
    const query = wrap($scope, ngQuery)
    const optionalEmitter = ngEmitter($scope)

    const callback = (result) => {
      if (result === get()) {
        return
      }

      if (optionalEmitter) {
        set(result)
        optionalEmitter.emit(result)
      } else {
        applyAsync($scope, set, result)
      }
    }

    const elementQuery = ElementQueryInternal($elm, query, callback)
    $scope.$on('$destroy', elementQuery.destroy)
  }
}
